import React from "react";
import { useNavigate } from 'react-router-dom';
import styles from "./MentionsLegalesPage.module.scss"; // Assurez-vous d'avoir un fichier SCSS correspondant

import Footer from '../../components/Footer/Footer';

const MentionsLegalesPage = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className={styles.container}>
        <h1>Mentions Légales</h1>

        <hr />
        <section>
          <h2>1. Éditeur du site / de l’application</h2>
          <p><strong>Nom de l’entreprise ou de l’éditeur :</strong> Hatanna Éditions (micro), représentée par Mme Célia Barbier.</p>
          <p><strong>Siège social :</strong> 173 Bd National 84400 APT</p>
          <p><strong>Numéro d’immatriculation (SIREN) :</strong> 832486237</p>
          <p><strong>Email de contact :</strong> <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a></p>
        </section>

        <section>
          <h2>2. Hébergement</h2>
          <p><strong>Nom de l’hébergeur :</strong> OVH RCS Roubaix – Tourcoing 424 761 419 00045 Code APE 6202A</p>
          <p><strong>Adresse :</strong> 2 rue Kellermann - 59100 Roubaix - France</p>
        </section>

        <section>
          <h2>3. Propriété intellectuelle</h2>
          <p>
            L’ensemble des contenus présents sur l’Application (textes, images, vidéos, codes sources, design, logo...)
            sont protégés par le droit de la propriété intellectuelle. Toute reproduction, diffusion ou modification,
            sans autorisation préalable, est interdite et pourra donner lieu à des poursuites.
          </p>
        </section>

        <section>
          <h2>4. Données personnelles et confidentialité</h2>
          <p>
            Les données collectées via l’Application sont traitées conformément à notre
            <a className={styles.link} onClick={() => navigate("/privacy")} rel="noopener noreferrer"> politique de confidentialité</a>.
            Conformément au <strong>Règlement Général sur la Protection des Données (RGPD)</strong>, vous disposez d’un droit
            d’accès, de rectification et de suppression de vos données personnelles en nous contactant à : [email de contact].
          </p>
        </section>

        <section>
          <h2>5. Responsabilité</h2>
          <p>
            L’éditeur de l’Application ne peut être tenu responsable en cas :
          </p>
          <ul>
            <li>D’interruptions temporaires du service dues à des opérations de maintenance.</li>
            <li>D’erreurs ou d’omissions dans le contenu affiché.</li>
            <li>De dommages liés à l’utilisation de l’Application par l’utilisateur.</li>
          </ul>
        </section>

        <section>
          <h2>6. Liens hypertextes</h2>
          <p>
            L’Application peut contenir des liens vers des sites tiers. L’éditeur décline toute responsabilité
            quant au contenu de ces sites et aux éventuelles conséquences de leur utilisation.
          </p>
        </section>

        <section>
          <h2>7. Droit applicable</h2>
          <p>
            Les présentes mentions légales sont régies par le droit français (ou autre juridiction selon votre pays).
            En cas de litige, les tribunaux compétents seront ceux du siège social de l’éditeur.
          </p>
        </section>

        <section>
          <h2>8. Développement</h2>
          <p>
            Cette application a été développée par <strong>Scriptales SAS</strong> (<a className={styles.link} href="https://scriptales.fr" target="_blank" rel="noopener noreferrer">https://scriptales.fr</a>).
          </p>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default MentionsLegalesPage;
